const API_URL = import.meta.env.VITE_API_URL || '';

/**
 * Resolves a relative upload path (e.g. /uploads/avatars/img.png) to a full URL.
 * In local dev the Vite proxy handles /uploads, but in deployed environments
 * we need to prepend the API base URL.
 */
export function resolveUploadUrl(path: string | undefined): string | undefined {
  if (!path) return undefined;
  // Already a full URL (e.g. https://...)
  if (path.startsWith('http')) return path;
  // Relative path — prepend API URL
  return `${API_URL}${path}`;
}
